import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import RoomList from '../components/RoomList';
import { getMaxCapacity } from '../api';

const SearchResults = () => {
    const location = useLocation();
    const { rooms, adults } = location.state || { rooms: [], adults: 1 };
    const [maxCapacity, setMaxCapacity] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMaxCapacity = async () => {
            try {
                const data = await getMaxCapacity();
                setMaxCapacity(data.max_capacity);
            } catch (error) {
                console.error('Error fetching max capacity:', error);
                setMaxCapacity(4); // Fallback to reasonable default
            } finally {
                setLoading(false);
            }
        };

        if (rooms.length === 0) {
            fetchMaxCapacity();
        } else {
            setLoading(false);
        }
    }, [rooms.length]);

    const renderNoRoomsMessage = () => {
        console.log('Rendering no rooms message...');
        console.log('Max Capacity:', maxCapacity, 'Adults:', adults);
        
        if (loading) {
            return <p>Loading...</p>;
        }

        const adultsCount = parseInt(adults) || 1;
        const exceedsCapacity = maxCapacity && adultsCount > maxCapacity;

        if (exceedsCapacity) {
            return (
                <div style={{ 
                    textAlign: 'center', 
                    padding: '20px',
                    color: '#2a3b5c',
                    lineHeight: '1.6'
                }}>
                    <p>
                        <strong>No Rooms Found</strong><br />
                        We couldn't find any rooms that can accommodate the number of adults you entered. 
                        Our largest room type has reached its maximum capacity.<br /><br />
                        👉 Try reducing the number of adults in your search and consider booking multiple rooms to fit your group.
                    </p>
                </div>
            );
        } else {
            return (
                <div style={{ 
                    textAlign: 'center', 
                    padding: '20px',
                    color: '#2a3b5c',
                    lineHeight: '1.6'
                }}>
                    <p>
                        <strong>No Rooms Available</strong><br />
                        No rooms are available for the selected dates. Please try different dates or adjust your search.
                    </p>
                </div>
            );
        }
    };

    console.log('SearchResults render - rooms:', rooms, 'maxCapacity:', maxCapacity, 'loading:', loading);
    return (
        <div>
            <h1>Search Results</h1>
            {rooms.length > 0 ? (
                <RoomList rooms={rooms} />
            ) : (
                renderNoRoomsMessage()
            )}
        </div>
    );
};

export default SearchResults;